var map = {
	"./back.png": 729,
	"./background.jpg": 730,
	"./board.png": 731,
	"./home.png": 732,
	"./lose.png": 733,
	"./losestar.png": 734,
	"./number-red-0.png": 735,
	"./number-red-1.png": 736,
	"./number-red-2.png": 737,
	"./number-red-3.png": 738,
	"./number-red-4.png": 739,
	"./number-red-5.png": 740,
	"./number-red-6.png": 741,
	"./number-red-7.png": 742,
	"./number-red-8.png": 743,
	"./number-red-9.png": 744,
	"./number-yellow-0.png": 745,
	"./number-yellow-1.png": 746,
	"./number-yellow-2.png": 747,
	"./number-yellow-3.png": 748,
	"./number-yellow-4.png": 749,
	"./number-yellow-5.png": 750,
	"./number-yellow-6.png": 751,
	"./number-yellow-7.png": 752,
	"./number-yellow-8.png": 753,
	"./number-yellow-9.png": 754,
	"./unuse.png": 755,
	"./win.png": 756,
	"./winstar.png": 757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 728;